import { WeightClass } from '~/apis/ssf';

export function formatWeightClass(wc: WeightClass): string {
  if (wc.max_weight === 999) {
    return `+${wc.min_weight}`;
  }

  return `-${wc.max_weight}`;
}

export function formatBodyWeight(weight: number): string {
  return weight.toFixed(2);
}

export function formatResultWeight(weight: number): string {
  return weight.toFixed(1);
}
